import { GeneralObject } from '../utils/types';
import {
  CashCollection,
  TGetAllCashCollectionParams,
  TCashCollectionDetails,
} from '../types';
import { emptySplitApi } from './emptySplitApi';

export const cashCollectionService =
  emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
      getAllCashCollectionList: builder.query<
        { data: CashCollection[]; totalCount: number },
        TGetAllCashCollectionParams
      >({
        query: (params) => ({
          url: 'cash-collection/search',
          method: 'GET',
          params: params,
        }),
        transformResponse: (
          data: CashCollection[],
          meta: Response
        ) => {
          const totalCount =
            meta.headers.get('X-total-count');
          return {
            data,
            totalCount: Number(totalCount ? totalCount : 0),
          };
        },
      }),
      getCashCollectionDetails: builder.query<
        TCashCollectionDetails,
        GeneralObject
      >({
        query: (data) => ({
          method: 'POST',
          url: `cash-collection/view-details`,
          data,
        }),
      }),
    }),
  });

export const {
  useGetAllCashCollectionListQuery,
  useGetCashCollectionDetailsQuery,
} = cashCollectionService;
